var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2296 9.65431C27.2303 9.63963 10.2025 26.8385 10.1816 48.0342C10.2025 69.2626 27.2303 86.4609 48.229 86.4552C69.2357 86.4609 86.2618 69.2626 86.2787 48.0342C86.2635 26.8385 69.2362 9.63963 48.2296 9.65431ZM64.1082 62.9148C63.1825 64.3801 60.8214 63.8608 61.6122 61.6662C65.293 51.4316 57.4725 49.3211 50.3079 49.3211H44.7633V59.3599L26.4886 44.2439L44.7633 29.1301V39.1683H46.7028C71.3512 39.1683 67.7941 57.0784 64.1082 62.9148Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBack);
export default __webpack_public_path__ + "static/media/sendBack.2be36f428ca78f44b7ba902435d53151.svg";
export { ForwardRef as ReactComponent };